import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {
  aktualizujKwoteRoszczenia,
  aktualizujParametryPrzedmiotu,
  aktualizujZbiorUszkodzenPrzedmiotow,
  usunZbiorUszkodzenPrzedmiotow
} from './zbiorUszkodzenPrzedmiotu.actions';
import {ZbiorUszkodzenPrzedmiotow} from './zbiorUszkodzenPrzedmiotow';
import {createReducer, on} from '@ngrx/store';


export interface ZbiorUszkodzenPrzedmiotowState extends EntityState<ZbiorUszkodzenPrzedmiotow<any>> {
}

export const adapterZbiorUszkodzenPrzedmiotow: EntityAdapter<ZbiorUszkodzenPrzedmiotow<any>> = createEntityAdapter<ZbiorUszkodzenPrzedmiotow<any>>();
export const initialZbiorUszkodzenPrzedmiotowState: ZbiorUszkodzenPrzedmiotowState = adapterZbiorUszkodzenPrzedmiotow.getInitialState();

export const zbiorUszkodzenPrzedmiotowReducer = createReducer<ZbiorUszkodzenPrzedmiotowState>(
  initialZbiorUszkodzenPrzedmiotowState,
  on(aktualizujZbiorUszkodzenPrzedmiotow, (state, action) => {
    const zbiorUszkodzenPrzedmiotow = {...state.entities[action.przedmiotId]};
    if (Object.keys(zbiorUszkodzenPrzedmiotow).length === 0) {
      return adapterZbiorUszkodzenPrzedmiotow.addOne(
        {
          id: action.przedmiotId,
          zbiorUszkodzenIds: new Array(action.zbiorUszkodzenId),
          parametry: undefined,
          kwotaRoszczenia: undefined
        },
        state
      );
    } else {
      if (zbiorUszkodzenPrzedmiotow.zbiorUszkodzenIds &&
        !zbiorUszkodzenPrzedmiotow.zbiorUszkodzenIds.find((zbiorUszkodzenId: string) => zbiorUszkodzenId === action.zbiorUszkodzenId)) {
        return adapterZbiorUszkodzenPrzedmiotow.updateOne(
          {
            id: action.przedmiotId,
            changes: {zbiorUszkodzenIds: [...zbiorUszkodzenPrzedmiotow.zbiorUszkodzenIds, action.zbiorUszkodzenId]}
          },
          state
        );
      } else {
        return {...state};
      }
    }
  }),
  on(aktualizujParametryPrzedmiotu, (state, action) => {
    const zbiorUszkodzenPrzedmiotow = {...state.entities[action.przedmiotId]};
    if (Object.keys(zbiorUszkodzenPrzedmiotow).length === 0) {
      return adapterZbiorUszkodzenPrzedmiotow.addOne(
        {
          id: action.przedmiotId,
          zbiorUszkodzenIds: [],
          parametry: action.parametry,
          kwotaRoszczenia: undefined
        },
        state
      );
    } else {
      return adapterZbiorUszkodzenPrzedmiotow.updateOne(
        {
          id: action.przedmiotId,
          changes: {parametry: action.parametry}
        },
        state
      );
    }
  }),
  on(usunZbiorUszkodzenPrzedmiotow, (state, action) => {
    const zbiorUszkodzenPrzedmiotow = {...state.entities[action.przedmiotId]};
    const zaktualizowanyZbiorUszkodzenIds = zbiorUszkodzenPrzedmiotow.zbiorUszkodzenIds?.filter((id: string) => id !== action.zbiorUszkodzenId)
    if (zaktualizowanyZbiorUszkodzenIds && zaktualizowanyZbiorUszkodzenIds.length === 0) {
      return adapterZbiorUszkodzenPrzedmiotow.removeOne(action.przedmiotId, state);
    } else {
      return adapterZbiorUszkodzenPrzedmiotow.updateOne(
        {
          id: action.przedmiotId,
          changes: {zbiorUszkodzenIds: zaktualizowanyZbiorUszkodzenIds}
        },
        state
      );
    }
  }),
  on(aktualizujKwoteRoszczenia, (state, action) => {
    const zbiorUszkodzenPrzedmiotow = {...state.entities[action.przedmiotId]};
    if (Object.keys(zbiorUszkodzenPrzedmiotow).length === 0) {
      return adapterZbiorUszkodzenPrzedmiotow.addOne(
        {
          id: action.przedmiotId,
          zbiorUszkodzenIds: [],
          parametry: undefined,
          kwotaRoszczenia: action.kwotaRoszczenia
        },
        state
      );
    } else {
      return adapterZbiorUszkodzenPrzedmiotow.updateOne(
        {
          id: action.przedmiotId,
          changes: {kwotaRoszczenia: action.kwotaRoszczenia}
        },
        state
      );
    }
  }),
)
